<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31">
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <g>
                <path fill="#E1F5FE" d="M21.77 11.458v13.75H1.147v-13.75H21.77zm0-9.166V8.02H1.147V2.29H21.77z" transform="translate(-1237 -391) translate(127 318) translate(855 3) translate(255 70) translate(3.75 1.25)" />
                <path
                  fill="#164194"
                  d="M2.292 6.875h18.333V2.292H2.292v4.583zm20.625 2.292H0V2.292C0 1.027 1.027 0 2.292 0h18.333c1.265 0 2.292 1.027 2.292 2.292v6.875zM22.917 27.5L0 27.5 0 11.458 2.292 11.458 2.292 25.208 20.625 25.208 20.625 13.75 4.583 13.75 4.583 11.458 22.917 11.458z"
                  transform="translate(-1237 -391) translate(127 318) translate(855 3) translate(255 70) translate(3.75 1.25)"
                />
                <path
                  fill="#13A2E8"
                  d="M4.583 18.333L9.167 18.333 9.167 16.042 4.583 16.042zM11.458 18.333L13.75 18.333 13.75 16.042 11.458 16.042zM16.042 18.333L18.333 18.333 18.333 16.042 16.042 16.042zM11.458 22.917L13.75 22.917 13.75 20.625 11.458 20.625zM5.729 22.917L8.021 22.917 8.021 20.625 5.729 20.625zM16.042 22.917L18.333 22.917 18.333 20.625 16.042 20.625z"
                  transform="translate(-1237 -391) translate(127 318) translate(855 3) translate(255 70) translate(3.75 1.25)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>